/**
 * @fileoverview POST handler for the "/alloys/adjust/custom_events/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAlloysAdjustCustomEventsAppGroupIdCacheKeys } from "./constants";
import type {
  PostAlloysAdjustCustomEventsAppGroupIdProps,
  PostAlloysAdjustCustomEventsAppGroupIdResult,
} from "./types";

export const postAlloysAdjustCustomEventsAppGroupId = reactQueryMutationAdapter(
  postAlloysAdjustCustomEventsAppGroupIdCacheKeys,
  (props: PostAlloysAdjustCustomEventsAppGroupIdProps): Promise<PostAlloysAdjustCustomEventsAppGroupIdResult> => {
    return fetch(`/alloys/adjust/custom_events/${props.appGroupId}`, "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
